import { render, staticRenderFns } from "./FeedingsTable.vue?vue&type=template&id=d0db2e88"
import script from "./FeedingsTable.vue?vue&type=script&lang=js"
export * from "./FeedingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports